// extracted by mini-css-extract-plugin
export default {"articlesListWrapper":"styles_articlesListWrapper__otcnu","contentWrapper":"styles_contentWrapper__Wh9-F"};